import {
  FETCH_PARTIESLIST_REQUEST,
  FETCH_PARTIESLIST_SUCCESS,
  FETCH_PARTIESLIST_FAILURE,
} from "./reletedPartiesListTypes";

const initialState = {
  loading: false,
  partiesList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PARTIESLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PARTIESLIST_SUCCESS:
      return {
        loading: false,
        partiesList: action.payload,
        error: "",
      };
    case FETCH_PARTIESLIST_FAILURE:
      return {
        loading: false,
        partiesList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
